module.exports = __webpack_public_path__ + "static/media/ellipsis.41f784d1.gif";